import * as Yup from 'yup'

const validationSchema = Yup.object().shape({
    nombre: Yup.string().required('El nombre es obligatorio'),
})

export default validationSchema